import en from '@locales/en.json'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

const resources = { en: { translation: en } }

i18n.use(initReactI18next).init({
  supportedLngs: ['en'],
  lng: 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
  resources
})
